import { render, staticRenderFns } from "./LProjectObject.vue?vue&type=template&id=df61ae06&scoped=true&"
import script from "./LProjectObject.vue?vue&type=script&lang=js&"
export * from "./LProjectObject.vue?vue&type=script&lang=js&"
import style0 from "./LProjectObject.vue?vue&type=style&index=0&id=df61ae06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df61ae06",
  null
  
)

export default component.exports